import { ApiError } from '@wundo/client/api.ts';

/**
 * What to put on screen when a request failed.
 *
 * The backend usually says why in a sentence of its own — "Topic set is in use
 * by 3 tracks", "This email address is already taken" — and `ApiError.detail`
 * carries it. That sentence beats anything the console can infer from a status
 * code, so it wins; `fallback` is what the screen says when there is none.
 *
 * `ApiError.message` is deliberately not the fallback: it is the generic line
 * naming the request, which is what Sentry groups on rather than something to
 * read.
 */
export function apiErrorMessage(failure: unknown, fallback: string): string {
  return (failure instanceof ApiError && failure.detail) || fallback;
}
